let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("9Bpw5")).then(() => parcelRequire('kArk5'));